import { css } from 'styled-system/css';

export const leagueIconStyle = {
	oddsBoostIcon: css({
		width: '24px',
		_galaxy: {
			transform: 'rotate(-30deg)',
		}
	})
}